import { TALENTQ_STORE_NAMES } from '@/stores_new/vacancy_talentq/constants';

export const PROJECT_ASSESSMENT_STORE_PREFIX = `vacancy_talentq/${TALENTQ_STORE_NAMES.PROJECT_FORM}/assessment_`;
